import React from 'react';
import { GraduationCap, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { EXAM_PRESETS } from '../../constants/presets';
import { trackStudentCTA } from '../../services/analytics';

const ExamPresets = ({ isDarkMode, onGetStarted }) => {
  const navigate = useNavigate();

  const handlePresetClick = () => {
    trackStudentCTA('exam_presets');
    onGetStarted('student');
  };

  return (
    <section data-testid="section-exam-presets" id="exam-presets" className={`py-16 md:py-24 ${isDarkMode ? 'bg-[#131C2E]' : 'bg-white'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className={`inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-bold mb-4 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`}>
            <GraduationCap className="w-4 h-4" />
            Exam Preparation
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-['Outfit'] tracking-tight mb-4">
            Exam-Style Presets
          </h2>
          <p className={`text-base sm:text-lg max-w-2xl mx-auto ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
            Pre-configured templates for NECTA, IGCSE, KCSE, WAEC, SAT, IELTS, and more
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {EXAM_PRESETS.slice(0, 12).map((preset) => (
            <button
              key={preset.id}
              onClick={handlePresetClick}
              data-testid={`exam-preset-${preset.id}`}
              className={`p-4 rounded-xl text-center transition-all hover:-translate-y-1 ${isDarkMode ? 'bg-slate-800/50 border border-slate-700 hover:border-purple-500' : 'bg-slate-50 border border-slate-200 hover:border-purple-400'}`}
            >
              <div className="text-2xl mb-2">{preset.icon}</div>
              <div className="text-sm font-bold truncate">{preset.name}</div>
            </button>
          ))}
        </div>

        <div className="text-center mt-8">
          <button onClick={() => navigate('/pricing')} className={`inline-flex items-center gap-2 text-sm font-medium ${isDarkMode ? 'text-purple-400 hover:text-purple-300' : 'text-purple-600 hover:text-purple-700'}`}>
            View all {EXAM_PRESETS.length} presets <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ExamPresets;
